import type { AuthUser } from "@bw/shared/hooks";

/**
 * Platform-wide access helpers shared across feature modules.
 *
 * This is the canonical home for the internal-employee / platform-console
 * gate so cross-domain pages (e.g. the users detail page) can import it
 * without reaching into a sibling feature module (`auth/`). The `auth`
 * module re-exports these for its own consumers.
 */

export const PLATFORM_ADMIN_EMAIL_DOMAIN = "badmintonwarriors.com";

export function isInternalPlatformEmail(email: string | null | undefined): boolean {
  const normalized = email?.trim().toLowerCase();
  return Boolean(normalized && normalized.endsWith(`@${PLATFORM_ADMIN_EMAIL_DOMAIN}`));
}

export function hasPlatformConsoleAccess(user: AuthUser | null | undefined): boolean {
  return Boolean(
    user?.customClaims?.platform_admin && isInternalPlatformEmail(user.email),
  );
}
